import { useRef, useState, useCallback } from "react";
import { Play } from "lucide-react";

const videos = [
  { id: 1, src: "/videos/1.mp4", poster: "/posters/poster1.jpg" },
  { id: 2, src: "/videos/2.mp4", poster: "/posters/poster2.jpg" },
  { id: 4, src: "/videos/4.mp4", poster: "/posters/poster4.jpg" },
  { id: 5, src: "/videos/5.mp4", poster: "/posters/poster5.jpg" },
  { id: 8, src: "/videos/8.mp4", poster: "/posters/poster8.jpg" },
  { id: 9, src: "/videos/9.mp4", poster: "/posters/poster9.jpg" },
  { id: 13, src: "/videos/13.mp4", poster: "/posters/poster13.jpg" },
  { id: 14, src: "/videos/14.mp4", poster: "/posters/poster14.jpg" },
  { id: 15, src: "/videos/15.mp4", poster: "/posters/poster15.jpg" },
  { id: 16, src: "/videos/16.mp4", poster: "/posters/poster16.jpg" },
  { id: 17, src: "/videos/17.mp4", poster: "/posters/poster17.jpg" },
];

function VideoCard({ video }) {
  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = useCallback(() => {
    setLoaded(true);
    // Bir sonraki frame'de video mount olur — play'i dene
    setTimeout(() => {
      if (videoRef.current) {
        const p = videoRef.current.play();
        if (p && typeof p.catch === "function") {
          p.catch(() => {
            /* kullanici manuel tiklayacak, controls var */
          });
        }
      }
    }, 50);
  }, []);

  return (
    <div className="relative aspect-[9/16] w-full overflow-hidden bg-black">
      {!loaded ? (
        <button
          type="button"
          onClick={handlePlay}
          aria-label="Videoyu oynat"
          className="group relative block h-full w-full cursor-pointer border-0 bg-black p-0"
        >
          <img
            src={video.poster}
            alt=""
            loading="lazy"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover"
          />
          {/* Hafif karartma — play ikonu okunsun */}
          <span className="absolute inset-0 block bg-gradient-to-t from-black/50 via-black/10 to-black/10 transition group-hover:from-black/60" />
          {/* Play butonu */}
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-xl ring-1 ring-black/10 transition group-hover:scale-110 group-active:scale-95">
              <Play
                size={28}
                className="ml-1 text-pink-600"
                fill="currentColor"
              />
            </span>
          </span>
        </button>
      ) : (
        <video
          ref={videoRef}
          className="h-full w-full bg-black object-contain"
          controls
          playsInline
          preload="auto"
          controlsList="nodownload"
          poster={video.poster}
        >
          <source src={video.src} type="video/mp4" />
          Tarayıcınız video oynatmayı desteklemiyor.
        </video>
      )}
    </div>
  );
}

export default function Videolar() {
  return (
    <section className="bg-gray-50 px-4 pt-16 pb-28 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gray-500">
            İçerikler
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            Videolar
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600">
            Psikoloji, ilişkiler ve duygusal iyi oluş alanlarında hazırlanan;
            bilimsel temelli, anlaşılır ve günlük hayata dokunan kısa video
            içerikler.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {videos.map((video) => (
            <div
              key={video.id}
              className="mx-auto w-full max-w-[320px] overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-black/5"
            >
              <VideoCard video={video} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
